import { styled } from '@mode/components';

export const Heading = styled('h1', {
  position: 'relative',
  lineHeight: '$90',
  color: '$g5',
  fontSize: '48px',
  backgroundColor: '$g2',
  fontFamily: '$serif',
  padding: '12px 20px',
  borderRadius: '$8',
  display: 'inline-block',
  textAlign: 'left',
  letterSpacing: '$minus3',
  '@md': {
    fontSize: '7vw',
    padding: '22px 20px',
    borderRadius: '$16',
  },
  '@xl': {
    fontSize: '96px'
  }
});

export const Animation = styled('div', {
  position: 'absolute',
  background: '$g4',
  width: 'calc(40% - 16px)',
  height: 'calc(45% - 16px)',
  top: 0,
  right: 0,
  borderRadius: '$8',
  zIndex: 50,
  'svg': {
    transform: 'unset!important'
  },
  '@md': {
    width: 'calc(27vw - 20px)',
    height: 'calc(40% - 22px)',
    borderRadius: '$16',
  },
  '@xl': {
    width: '20.5%',
    height: '40.8%',
  }
})
